(ns frontend.ui.component.heading.view
  (:require
   [frontend.ui.component.heading.style :as style]
   [herb.core :refer [<class]]))

(defn h1
  [child]
  [:h1
   {:class (<class style/h1)}
   child])

(defn h2
  [child]
  [:h2
   {:class (<class style/h2)}
   child])

(defn h3
  [child]
  [:h3
   {:class (<class style/h3)}
   child])

(defn h4
  [child]
  [:h4
   {:class (<class style/h4)}
   child])

(defn h5
  [child]
  [:h5
   {:class (<class style/h5)}
   child])

(defn h6
  [child]
  [:h6
   {:class (<class style/h6)}
   child])
